module.exports = __webpack_public_path__ + "img/icon_defalutimage_gray.437677b0.png";